import { Flex, Menu, MenuButton, Button, Avatar, Heading, MenuList, MenuDivider, MenuItem, Image, Badge, Spinner, Tooltip, Box, Text } from '@chakra-ui/react';
import { NavLink, useNavigate } from 'react-router-dom';
import { BellIcon, PhoneIcon } from '@chakra-ui/icons';
import * as routesNames from '../../constants/routes';
import ArrowDownIcon from '../../assets/images/arrow-down.svg';
import MyDiv from './navBar.style';
import { useAuth } from '../../hooks/useAuth';
import { useEffect, useState } from 'react';
import { baseUrl } from '../../hooks/useFetch';
import DummyPerson from '../../assets/images/DummyPerson.svg';
import { useFetch } from '../../hooks/useFetch';
import CustomToast from '../CustomToast';
// import { UpdatePassword } from '../../views';

const NavBar = () => {
  const navigate = useNavigate();
  const { logout, employeeName, employeeId, loginObj, hasPermission } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [isUpdatePasswordOpen, setIsUpdatePasswordOpen] = useState(false);

  const fetchAvatar = async () => {
    try {
      const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${employeeId}`, {
        headers: { Authorization: `Bearer ${loginObj?.token || ''}` }
      });
      const blob = await res.blob();
      setAvatarUrl(URL.createObjectURL(blob));
    } catch { }
  };

  const handleLogout = async () => {
    logout();
  };


  useEffect(() => {
    const updateAvatar = (e: any) => setAvatarUrl(e.detail);
    window.addEventListener('avatarUpdated', updateAvatar);
    return () => window.removeEventListener('avatarUpdated', updateAvatar);
  }, []);




  return (
    <MyDiv>
      <Flex align="center" justify="space-between">

        {/* <Menu>
          <Tooltip label="Notifications" placement="bottom">
            <MenuButton as={Button} variant="ghost" p={2} position="relative" mr={3}
              _hover={{ bg: 'gray.100' }} className="blink_bell">
              <BellIcon boxSize={5} color="gray.700" />
              {notifications.length > 0 && (
                <Badge colorScheme="red" borderRadius="full" position="absolute"
                  top="2px" right="2px" fontSize="0.7em" className="blink_badge">
                  {notifications.length}
                </Badge>
              )}
            </MenuButton>
          </Tooltip>

          <MenuList w="540px" maxH="300px" overflowY="auto" boxShadow="lg"
            borderRadius="md" bg="white" px={2}
            css={{
              '&::-webkit-scrollbar': { width: '6px' },
              '&::-webkit-scrollbar-thumb': { background: '#CBD5E0', borderRadius: '4px' },
              '&::-webkit-scrollbar-thumb:hover': { background: '#A0AEC0' },
            }}>
            {notificationsLoading ? (
              <Flex justify="center" align="center" py={4}>
                <Spinner size="sm" />
              </Flex>
            ) : notifications.length === 0 ? (
              <Box p={4}>
                <Text fontSize="sm" color="gray.500" textAlign="center">
                  No new notifications
                </Text>
              </Box>
            ) : (
              notifications.map((n, idx) => (
                <MenuItem key={idx} onClick={() => navigateRoutes(n)}
                  borderRadius="md" _hover={{ bg: 'gray.50' }} whiteSpace="normal">
                  <Box>
                    <Text className="font-poppins text_regular text_sm">
                      {getNotificationIcon(n)} {n?.message}
                    </Text>
                  </Box>
                </MenuItem>
              ))
            )}
          </MenuList>
        </Menu> */}

        {/* <Box mr={3}>
          <Menu placement="bottom-start">
            <MenuButton as={Button} leftIcon={<PhoneIcon color="green.500" />}
              bg="#FFFFFF" borderRadius="lg" px={4} py={2}
              className='font-poppins text_md text_medium'>
              Support Call
            </MenuButton>
            <MenuList minW="220px">
              <MenuItem>
                <Box>
                  <Text fontWeight="semibold" color="green.600">HR Department</Text>
                  <Text fontSize="sm">{ivrRecord?.hr_No}</Text>
                </Box>
              </MenuItem>
              <MenuItem>
                <Box>
                  <Text fontWeight="semibold" color="green.600">Account Team</Text>
                  <Text fontSize="sm">{ivrRecord?.accountant_No}</Text>
                </Box>
              </MenuItem>
            </MenuList>
          </Menu>
        </Box> */}

        {/* 👤 Profile Dropdown */}
        <Menu>
          <Flex className="profile_menu">
            <MenuButton as={Button}
              leftIcon={<Avatar size='2xs' src={avatarUrl || DummyPerson} />}
              rightIcon={<Image src={ArrowDownIcon} />}>
              <Heading as="h1" className="font-poppins font_dark text_semibold text_md">
                {employeeName}
              </Heading>
            </MenuButton>
          </Flex>
          <MenuList className="dropdown_list">
            {/* <MenuItem onClick={handleNavigate} className="font-poppins font_dark text_medium text_md">
              My Profile
            </MenuItem>
            <MenuDivider mt={0} mb={0} className="divider" />
            <MenuItem as={NavLink} to={routesNames.EMPLOYEEGALLERY}
              className="font-poppins font_dark text_medium text_md">
              Gallery
            </MenuItem>
            <MenuDivider mt={0} mb={0} className="divider" />
            {hasPermission('Master', 'Masters') && (
              <MenuItem as={NavLink} to={routesNames.Master}
                className="font-poppins font_dark text_medium text_md">
                Master
              </MenuItem>
            )} */}

            <MenuDivider mt={0} mb={0} className="divider" />
            <MenuItem onClick={handleLogout}
              className="font_poppins font_dark text_md text_medium logout_user">
              Logout
            </MenuItem>


          </MenuList>
        </Menu>

      </Flex>
      {/* <UpdatePassword
  isOpen={isUpdatePasswordOpen}
  onClose={() => setIsUpdatePasswordOpen(false)}
/> */}
    </MyDiv>
  );
};

export default NavBar;
